export const TOOLTIP_EVENTS = {
  TOOLTIP_OPENED: "gc-tooltip-opened"
};

export const CATALOG_EVENTS = {
  FILTER_SELECTION: "filter-selection"
};

export const DATE_PICKER_EVENTS = {
  DATE_SELECTED: "calendar.dateSelected",
  DATE_CHANGED: "dates-changed"
};

export const AVAILABLE_NOW_SERVICE_EVENTS = {
  SET_AVAILABLE_NOW: "set-available_now"
};

export const BAG_PAGE_EVENTS = {
  PRODUCTS_NO_LONGER_AVAILABLE: "bag-page--products-no-longer-available",
  REPLACE_PRODUCT_CLICKED: "bag-page--replace-product-clicked"
};

export const PRODUCT_CALENDAR_SERVICE_EVENTS = {
  FETCH_ON_DEMAND_AVAILABILITY_FAILURE: "product-calendar-service--fetch-on-demand-availabilities-failure",
  FETCH_ON_DEMAND_AVAILABILITY_SUCCESS: "product-calendar-service--fetch-on-demand-availabilities-success"
};

export const POSTCODE_SERVICE_EVENTS = {
  SET_POSTCODE: "set-postcode"
};

export const PRODUCT_PAGE_EVENTS = {
  FALLBACK_TO_MAKING_ALL_SIZES_AVAILABLE: "product-page--fallback-to-making-all-sizes-available"
};

export const EMBED_APP_EVENTS = {
  EMBED_APP_LOADED: "embed-app-loaded"
};

export const CUSTOMER_LOGOUT = "customer-logout";

export const ROOT_DOMAIN = "glamcorner.com.au";
